import { render } from "./StarLeftSide.vue?vue&type=template&id=7e29d632"
import script from "./StarLeftSide.vue?vue&type=script&lang=js"
export * from "./StarLeftSide.vue?vue&type=script&lang=js"

import "./StarLeftSide.vue?vue&type=style&index=0&id=7e29d632&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__